let faqTrigger = document.querySelectorAll('.js-faq-item');

faqTrigger.forEach(trigger => {
	trigger.addEventListener('click', () => {
		console.log(trigger)
		let content = trigger.querySelector('.js-faq-content');
		let icon = trigger.querySelector('.js-faq-icon')
		content.classList.toggle('is-visible');
		icon.classList.toggle('is-rotate');
	})
})
